import React from 'react';
import { FormattedMessage } from 'react-intl';
import { formatMoney } from '../../util/currency';

export const ORDER_PANEL_PRICE_UNIT_MESSAGE_ID = 'PackageCard.perGuestText';

// Desktop order panel price + unit. The unit is always "per Guest".
export const getOrderPanelPriceLabel = (intl, startingPrice) => ({
  formattedPrice: formatMoney(intl, startingPrice),
  unitMessageId: startingPrice?.amount ? ORDER_PANEL_PRICE_UNIT_MESSAGE_ID : null,
});

const PackageStartingPrice = ({ intl, startingPrice, priceClassName, unitClassName }) => {
  const { formattedPrice, unitMessageId } = getOrderPanelPriceLabel(intl, startingPrice);

  return (
    <>
      <span className={priceClassName}>{formattedPrice}</span>
      {unitMessageId ? (
        <span className={unitClassName}>
          <FormattedMessage id={unitMessageId} />
        </span>
      ) : null}
    </>
  );
};

export default PackageStartingPrice;
